import { InlineIcon } from "@iconify/react";
import React from "react";
import { createUseStyles } from "react-jss";
import jssVariables from "../../jss_setup";

const styles = createUseStyles({
  SuccessfulPayment: {
    display: "grid",
    gridGap: jssVariables.normal_gap,
    alignContent: "center",
    justifyContent: "center",
    placeItems: "center",
    textAlign: "center",
  },
  loaderIcon: {
    fontSize: "xxx-large",
  },
});

const SuccessfulPayment = () => {
  const classes = styles();

  return (
    <div className={classes.SuccessfulPayment}>
      <InlineIcon icon="eos-icons:loading" className={classes.loaderIcon} />
      <h4>Please wait whilst we are finalising your booking.</h4>
    </div>
  );
};

export default SuccessfulPayment;
